var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgToolAlign(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7724 7.20296H14.0621V4.05167C14.0621 3.30436 13.4406 2.70111 12.6707 2.70111C11.9008 2.70111 11.2794 3.30436 11.2794 4.05167V7.20296H7.56905V1.35056C7.56905 0.603248 6.94757 0 6.17768 0C5.40779 0 4.78631 0.603248 4.78631 1.35056V7.20296H0.927579C0.417411 7.20296 0 7.60813 0 8.10333C0 8.59854 0.417411 9.0037 0.927579 9.0037H4.78631V14.8561C4.78631 15.6034 5.40779 16.2067 6.17768 16.2067C6.94757 16.2067 7.56905 15.6034 7.56905 14.8561V9.0037H11.2794V12.155C11.2794 12.9023 11.9008 13.5056 12.6707 13.5056C13.4406 13.5056 14.0621 12.9023 14.0621 12.155V9.0037H17.7724C18.2826 9.0037 18.7 8.59854 18.7 8.10333C18.7 7.60813 18.2826 7.20296 17.7724 7.20296Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolAlign);
export default __webpack_public_path__ + "static/media/toolAlign.fed0e77a.svg";
export { ForwardRef as ReactComponent };